module.exports = __webpack_public_path__ + "img/picture_48.4a251002.png";